<template>
  <v-dialog scrollable v-model="dialog" max-width="1400">
    <v-card>
      <v-card-title class="headline">{{ title }}</v-card-title>
      <v-card-text>
        <iframe
          width="100%"
          height="500"
          frameborder="0"
          :src="htmlUrl"
          @load="handleIFrameLoaded"
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text color="accent" @click="handleClose">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
const DEFAULT_TITLE = 'Preview';

export default {
  data() {
    return {
      dialog: false,
      title: DEFAULT_TITLE,
      htmlUrl: null
    };
  },
  methods: {
    open(title, htmlUrl) {
      this.dialog = true;
      this.title = title;
      this.htmlUrl = htmlUrl;
    },
    handleIFrameLoaded(frame) {
      const [iFrameEl] = frame.path;

      iFrameEl.style.height = `${iFrameEl.contentWindow.document.body.scrollHeight + 50}px`;
    },
    handleClose() {
      this.dialog = false;
      this.title = DEFAULT_TITLE;
      this.htmlUrl = null;
    }
  }
};
</script>
